module.exports = __webpack_public_path__ + "static/media/grid.c894b5c1.png";